module.exports = __webpack_public_path__ + "img/i_12_h.9d81cb65.png";